module.exports = __webpack_public_path__ + "media/images/icons/academy-mandarin-2d1c9510df01d50ce0fd5e24a7214367.svg";